var map = {
	"./featured-story.jpg": 130,
	"./home.jpg": 131,
	"./icons/arro-right-normal.svg": 132,
	"./icons/arrow-down-short.svg": 133,
	"./icons/arrow-left-black.svg": 134,
	"./icons/arrow-left-gold.svg": 135,
	"./icons/arrow-left-white.svg": 136,
	"./icons/arrow-right-black.svg": 137,
	"./icons/arrow-right-gold.svg": 138,
	"./icons/arrow-right-white.svg": 139,
	"./icons/arrow-up-short.svg": 140,
	"./icons/icon-chevron-down.svg": 141,
	"./icons/icon-facebook.svg": 142,
	"./icons/icon-instagram.svg": 143,
	"./icons/icon-search.svg": 144,
	"./icons/icon-twitter.svg": 145,
	"./image.jpg": 146,
	"./landing-hero.jpg": 147,
	"./logo-horizontal.svg": 148,
	"./logo.svg": 149,
	"./news.jpg": 150,
	"./profile-hero.jpg": 151,
	"./reverse-tile.jpg": 152,
	"./standard-hero-image.jpg": 153,
	"./tile.jpg": 154,
	"./values-slider.jpg": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;